import React, {FC} from "react";
import { ButtonStyled, ModalStyled } from "./style";
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IconButton from 'components/IconButton/icon-button';

interface AceiteLgpdModalProps {
    show: boolean;
    handleAccept: () => void;
    handleDecline: () => void;
}

const AceiteLgpdModal: FC<AceiteLgpdModalProps> = ({show, handleAccept, handleDecline}) => {
    return(
        <ModalStyled
            backdrop={true}
            show={show}
            centered
            dialogClassName="modal-528"
        >
            <ModalStyled.Header>
                <ModalStyled.Title className="modal-title">
                    Termo de Consentimento - LGPD
                </ModalStyled.Title>
                <IconButton
                    size="24px"
                    color="#BBC8DB"
                    onClick={() => handleDecline()}
                    icon={faTimesCircle}
                />
            </ModalStyled.Header>
            <ModalStyled.Body>
                <p>
                    Para a realização de campanhas junto aos estudantes que ainda não guardam
                    relação jurídica com a Fundacred e não submeteram seus dados à análise no
                    Portal da Fundacred, atuamos na qualidade de operadores de dados,
                    realizando o tratamento dos respectivos dados em nome e por conta da
                    Mantenedora e IEs, que garantem que os dados pessoais ora compartilhados,
                    bem como a atividade que será realizada estão amparados por uma base legal
                    válida, legítima e adequada para a(s) finalidade(s).
                    <br/>
                    <br/>
                    Em contrapartida, a Fundacred se compromete em atender às instruções da 
                    controladora e a utilizar os dados apenas na medida necessária para realização
                    da(s) campanha(s), comprometendo com a eliminação após o cumprimento do 
                    quanto proposto.
                </p>

                <ButtonStyled
                    onClick={handleAccept}
                >
                    Li e Concordo
                        <FontAwesomeIcon icon = {faCheck}/>
                </ButtonStyled>

            </ModalStyled.Body>
        </ModalStyled>
    )
}

export default AceiteLgpdModal;